// PRESET_TAGS removed — the chip universe for dietary/origins/allergens
// now comes from the BE tags JsonAsset registry via `useTagsRegistry()`.
// Single source of truth lives in `dist/seed/SeedJsonAssets/tags-*-*.json`
// on the BE; FE consumes through the public `GET /tags` endpoint.

// Currently unreferenced, and deliberately kept: this is the entry point for
// drop-off. Delivery used to be the second entry here until it was torn out
// (it was never shipped — the publish form kept it disabled behind a "Coming
// soon" badge), which left pickup as the only method and made the publish
// page's fulfillment picker a lone checkbox that did nothing. That picker is
// gone, so nothing consumes this today.
//
// Adding drop-off starts by pushing a second entry here, then:
//   - `FulfillmentMethod` in src/types/listing.ts (currently `'pickup'`)
//   - `FulfillmentMethodPickup` + IsValidFulfillmentMethod in the BE's
//     updraft/backend/model/dish.go — the BE rejects unknown values, so it has
//     to accept the new one before the FE can send it
//   - new `fulfillment.<method>` keys in public/locales/{en,es-MX}/publish.json
//   - re-add the picker section in PublishListingPage (the `fulfillment` state,
//     pending-publish buffer field, and edit rehydrate were all left in place)
//
// PortionPickerModal's method selector is already guarded on
// `methods.length > 1`, so it starts rendering on its own once a listing can
// offer two.
export const FULFILLMENT_OPTIONS = [
  { value: 'pickup', label: 'Pick-up' },
];

export const SPICINESS_LEVELS = [0, 1, 2, 3];
